import ERPSGrid from "./ERPSGrid";
import CardList from "./cardList";
import ERPSBaseButton from "../inputs/ERPSBaseButton";
import ERPSBaseDiv from "../inputs/ERPSBaseDiv";
import ERPSBaseTextField from "../inputs/ERPSBaseTextField";
import ERPSBaseDatePicker from "../inputs/ERPSDatePicker";
import { useEffect, useRef } from "react";
import ErrorMessage from "./ErrorMessage";
import { useTranslation } from "react-i18next";
import LoadingIcon from "../inputs/ERPSLoadingIcon";
import { ResponsiveBox, Box, HGrid, Tooltip, Typography, InputAdornment } from "../../primitives";

export default function CommonLayout(props) {
  const {
    pageTitle,
    pageDescription,
    pageAltDescription,
    primaryButtonLabel,
    pageSubHeading,
    pageSubHeadingDescription,
    errorMssg,
    primaryButtonLabelV2,
    secondaryButtonLabel,
    searchResultLabel,
    searchResultFoundLabel,
    startSearchHandler,
    searchCriteriaChangeHandler,
    resetHandler,
    navigateToNewUserComponent,
    isSearchValid,
    warningIcon,
    searchCriteria,
    initiateSearch,
    searchResults,
    searchNotStarted,
    pageName,
    firstTextInputFieldId,
    firstTextInputFieldLabel,
    secondTextInputFieldId,
    secondTextInputFieldLabel,
    thirdTextInputFieldId,
    thirdTextInputFieldLabel,
    fourthTextInputFieldId,
    fourthTextInputFieldLabel,
    pathName,
    isRequired = "true",
    history,
    loading,
    dataGridWidth,
    sumOfColumnWidth,
    hideFooterPagination = false,
    componentAccess,
    pageNumber,
    rowPerPage,
    searchCriteriaBlurHandler,
    actionType: {
      primaryButtonActionTypeV1,
      firstTextInputFieldActionType,
      secondTextInputFieldActionType,
      thirdTextInputFieldActionType,
      fourthTextInputFieldActionType,
      primaryButtonActionTypeV2,
      secondaryButtonActionType,
    },
    isDisabled = true,
    hasNewButtonVisible = true,
    isEnable,
    initialLoading,
    initialStates,
    reportNameList,
    highlightError,
    hasDropDownLoading,
    minDateVal,
    maxDateVal,
    subscribeEntityList,
    errorRef,
  } = props;

  const { t } = useTranslation();

  const getCardData = () => {
    const tempSearchResults = { ...searchResults };
    const { rows, columns, count } = tempSearchResults;
    const columnValues = columns.map(({ field }) => field);
    const cardData = rows.map((row) => {
      let rowData = {};
      columnValues.forEach((colValue) => {
        let updatedKey = "";
        if (colValue === "billingModelDescription") {
          updatedKey = "pricePlaneName";
        } else if (colValue === "billingModelNumber") {
          updatedKey = "pricePlanId";
        } else {
          updatedKey = colValue;
        }
        rowData = { ...rowData, [updatedKey]: row[colValue] };
      });
      return rowData;
    });
    return { rows: cardData, count, columns };
  };

  const highlightErrorField = () => {
    // Highlight 'Biller name' field if invalid wild card error
    return (
      !isSearchValid &&
      pageName == "manage-billers" &&
      errorMssg ==
        t(
          "erps.billermanagement.filterbillercategory.error.invaliduseofwildcardcharacter"
        )
    );
  };

  return (
    <div role="main">
      <Box ml={3}>
        <Box
          className="manageUsers__page__title"
          sx={{ width: { xs: "100%", lg: "66.666%" }, maxWidth: "100%" }}
        >
          <Typography variant="h1">{pageTitle}</Typography>
        </Box>
        <ERPSBaseDiv
          actionType={primaryButtonActionTypeV1}
          componentAccess={componentAccess}
        >
          <Box
            className="manageUsers__wrap__box"
            sx={{ width: { xs: "100%", lg: "66.666%" }, maxWidth: "100%" }}
          >
            <Typography variant="body1">{pageDescription}</Typography>
          </Box>
          <Box mt={-4}>
            {hasNewButtonVisible && (isEnable || !isDisabled) && (
              <ERPSBaseButton
                variant="primary"
                actionType={primaryButtonActionTypeV1}
                className="button_with_margin48"
                label={primaryButtonLabel}
                componentAccess={componentAccess}
                onClick={navigateToNewUserComponent}
              />
            )}
          </Box>
        </ERPSBaseDiv>
        <Box
          mt={isEnable || !isDisabled ? 4 : 6}
          sx={{ width: { xs: "100%", lg: "66.666%" }, maxWidth: "100%" }}
        >
          <Typography variant="h2">{pageSubHeading}</Typography>
        </Box>
        <Box
          mt={1}
          sx={{ width: { xs: "100%", lg: "66.666%" }, maxWidth: "100%" }}
        >
          <Typography variant="body1">{pageSubHeadingDescription}</Typography>
        </Box>
        <ErrorMessage
          error={
            (!isSearchValid && errorMssg) ||
            (Array.isArray(errorMssg) && errorMssg.length ? errorMssg : null)
          }
          errorRef={errorRef}
          mt={2}
          sx={{ width: { xs: "100%", lg: "66.666%" }, maxWidth: "100%" }}
        />

        <Box sx={{width: {xs: "100%", md: pageName === "manage-biller-cross-reference" ? "800px" : "650px",}, maxWidth: "100%",}}>
          <HGrid container spacing={2}>
            {pageName === "download-reports" ? (
              // For Download report page
              <>
                <HGrid item xs={12} md={4}>
                  <ERPSBaseDatePicker
                    label={firstTextInputFieldLabel}
                    value={searchCriteria.startDate || null}
                    onChange={searchCriteriaChangeHandler("startDate")}
                    minDate={minDateVal}
                    error={highlightError?.startDate}
                    id={`${pageName}-${firstTextInputFieldLabel}`}
                    maxDate={maxDateVal}
                  />
                </HGrid>
                <HGrid item xs={12} md={4}>
                  <Box sx={{ pl: { xs: 0, md: 1 } }}>
                    <ERPSBaseDatePicker
                      label={secondTextInputFieldLabel}
                      value={searchCriteria.endDate || null}
                      onChange={searchCriteriaChangeHandler("endDate")}
                      minDate={minDateVal}
                      error={highlightError?.endDate}
                      id={`${pageName}-${secondTextInputFieldLabel}`}
                      maxDate={maxDateVal}
                    />
                  </Box>
                </HGrid>
                <HGrid item xs={12} md={4}>
                  <Box sx={{ pl: { xs: 0, md: 1 } }}>
                    <ERPSBaseTextField
                      id="reportname__list"
                      type="text"
                      select={true}
                      label={thirdTextInputFieldId}
                      className="three_column__textField downloadreports__reportname"
                      size="small"
                      value={searchCriteria.reportName || ""}
                      items={reportNameList}
                      SelectProps={{ native: true }}
                      onChange={searchCriteriaChangeHandler("reportName")}
                      loading={hasDropDownLoading}
                      error={highlightError?.reportName}
                      inputProps={{
                        startAdornment: hasDropDownLoading && (
                          <InputAdornment style={{ margin: "0px 120px" }}>
                            <LoadingIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </HGrid>
                {subscribeEntityList && (
                <>
                  <HGrid item xs={12} md={8}>
                    {/* Empty cell, so that subscribeEntityId dropdown is poistioned right under reportname__list */}
                  </HGrid>
                  <HGrid item xs={12} md={4}>
                    <Box sx={{ pl: { xs: 0, md: 1 } }}>
                      <ERPSBaseTextField
                        id="subscribeEntityId"
                        type="text"
                        select={true}
                        label={t("erps.newuser.label.subscribingentityid")}
                        className="three_column__textField downloadreports__reportname"
                        size="small"
                        value={searchCriteria.fiCompanyNumber || ""}
                        items={subscribeEntityList}
                        required={true}
                        error={highlightError?.subscribeEntityId || highlightError?.fiCompanyNumber}
                        SelectProps={{ native: true }}
                        onChange={searchCriteriaChangeHandler("fiCompanyNumber")}
                        loading={hasDropDownLoading}
                        inputProps={{
                          startAdornment: hasDropDownLoading && (
                            <InputAdornment style={{ margin: "0px 120px" }}>
                              <LoadingIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                  </HGrid>
                </>
                )}
              </>
            ) : pageName === "manage-biller-cross-reference" ? (
              <>
                <HGrid item xs={12} sm={6} md={3}>
                  <ERPSBaseTextField
                    id={firstTextInputFieldId}
                    type="text"
                    label={firstTextInputFieldLabel}
                    className="common__textField__width"
                    required={isRequired}
                    size="small"
                    onChange={searchCriteriaChangeHandler(firstTextInputFieldId)}
                    value={searchCriteria[firstTextInputFieldId]}
                    actionType={firstTextInputFieldActionType}
                    componentAccess={componentAccess}
                    error={highlightError?.[firstTextInputFieldId] || highlightErrorField()
                    }
                  />
                </HGrid>
                <HGrid item xs={12} sm={6} md={3}>
                  <Box sx={{ pl: { xs: 0, md: 1 } }}>
                    <ERPSBaseTextField
                      id={secondTextInputFieldId}
                      type="text"
                      label={secondTextInputFieldLabel}
                      className="common__textField__width"
                      required={isRequired}
                      size="small"
                      onChange={searchCriteriaChangeHandler(secondTextInputFieldId)}
                      value={searchCriteria[secondTextInputFieldId]}
                      actionType={secondTextInputFieldActionType}
                      componentAccess={componentAccess}
                      error={highlightError?.[secondTextInputFieldId] || highlightErrorField()}
                    />
                  </Box>
                </HGrid>
                <HGrid item xs={12} sm={6} md={3}>
                  <Box sx={{ pl: { xs: 0, md: 1 } }}>
                    <ERPSBaseTextField
                      id={thirdTextInputFieldId}
                      type="text"
                      label={thirdTextInputFieldLabel}
                      className="common__textField__width"
                      required={isRequired}
                      size="small"
                      onChange={searchCriteriaChangeHandler(thirdTextInputFieldId)}
                      value={searchCriteria[thirdTextInputFieldId]}
                      actionType={thirdTextInputFieldActionType}
                      componentAccess={componentAccess}
                      error={highlightError?.[thirdTextInputFieldId]}
                    />
                  </Box>
                </HGrid>
                <HGrid item xs={12} sm={6} md={3}>
                  <Box sx={{ pl: { xs: 0, md: 1 } }}>
                    <ERPSBaseTextField
                      id={fourthTextInputFieldId}
                      type="text"
                      label={fourthTextInputFieldLabel}
                      className="common__textField__width"
                      required={isRequired}
                      size="small"
                      onChange={searchCriteriaChangeHandler(fourthTextInputFieldId)}
                      value={searchCriteria[fourthTextInputFieldId]}
                      actionType={fourthTextInputFieldActionType}
                      componentAccess={componentAccess}
                      error={highlightError?.[fourthTextInputFieldId]}
                    />
                  </Box>
                </HGrid>
              </>
            ) : (
              <>
                <HGrid item xs={12} md={4}>
                  <ERPSBaseTextField
                    id={firstTextInputFieldId}
                    type="text"
                    label={firstTextInputFieldLabel}
                    className="common__textField__width"
                    required={isRequired}
                    size="small"
                    onChange={searchCriteriaChangeHandler(
                      firstTextInputFieldId
                    )}
                    value={searchCriteria[firstTextInputFieldId]}
                    actionType={firstTextInputFieldActionType}
                    componentAccess={componentAccess}
                    error={highlightError?.[firstTextInputFieldId] || highlightErrorField()}
                  />
                </HGrid>
                <HGrid item xs={12} md={4}>
                  <Box sx={{ pl: { xs: 0, md: 1 } }}>
                    {pageName === "manage-billers" ? (
                      <ERPSBaseTextField
                        id={secondTextInputFieldId}
                        type="text"
                        label={secondTextInputFieldLabel}
                        className="common__textField__width"
                        required={isRequired}
                        size="small"
                        onChange={searchCriteriaChangeHandler(
                          secondTextInputFieldId
                        )}
                        value={searchCriteria[secondTextInputFieldId]}
                        actionType={secondTextInputFieldActionType}
                        componentAccess={componentAccess}
                        error={highlightError?.[secondTextInputFieldId] || highlightErrorField()}
                        onBlur={searchCriteriaBlurHandler(
                          secondTextInputFieldId
                        )}
                      />
                    ) : (
                      <ERPSBaseTextField
                        id={secondTextInputFieldId}
                        type="text"
                        label={secondTextInputFieldLabel}
                        className="common__textField__width"
                        required={isRequired}
                        size="small"
                        onChange={searchCriteriaChangeHandler(
                          secondTextInputFieldId
                        )}
                        value={searchCriteria[secondTextInputFieldId]}
                        actionType={secondTextInputFieldActionType}
                        componentAccess={componentAccess}
                        error={highlightError?.[secondTextInputFieldId] || highlightErrorField()}
                      />
                    )}
                  </Box>
                </HGrid>
                {(pageName === "manage-users" ||
                  pageName === "biller-profile") && (
                  <HGrid item xs={12} md={4}>
                    <Box sx={{ pl: { xs: 0, md: 2 } }}>
                      <ERPSBaseTextField
                        id={thirdTextInputFieldId}
                        type="text"
                        label={thirdTextInputFieldLabel}
                        className="common__textField__width"
                        required={isRequired}
                        size="small"
                        onChange={searchCriteriaChangeHandler(
                          thirdTextInputFieldId
                        )}
                        value={searchCriteria.lastName}
                        actionType={thirdTextInputFieldActionType}
                        componentAccess={componentAccess}
                        error={highlightError?.[thirdTextInputFieldId]}
                      />
                    </Box>
                  </HGrid>
                )}
              </>
            )}
          </HGrid>
        </Box>

        <Box
          mt={-3} 
          sx={{ 
            display: "flex", 
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 0 },
            "& > button": {
              width: { xs: "100%", sm: "auto" }
            }
          }}
        >
          <ERPSBaseButton
            variant="secondary"
            actionType={primaryButtonActionTypeV2}
            className="button_with_margin48"
            label={primaryButtonLabelV2}
            onClick={resetHandler}
            componentAccess={componentAccess}
          />
          <Box sx={{
            pl: { xs: 0, sm: 2 },
            width: { xs: "100%", sm: "auto" },
            "& > button": {
              width: { xs: "100%", sm: "auto" }
            }
          }}>
            <ERPSBaseButton
              variant="primary"
              actionType={secondaryButtonActionType}
              className="button_with_margin48"
              label={secondaryButtonLabel}
              onClick={startSearchHandler}
              loading={loading}
              componentAccess={componentAccess}
            />
          </Box>
        </Box>

        <Box
          mt={4}
          sx={{ width: { xs: "100%", lg: "66.666%" }, maxWidth: "100%" }}
        >
          <Typography variant="h2">{searchResultLabel}</Typography>
        </Box>

        {searchResults !== null &&
          searchResults !== undefined &&
          searchResults.count !== null &&
          searchResults.count !== -1 && (
            <Box
              marginTop={1} 
              marginBottom={1.5} 
              sx={{ 
                display: "flex",
                width: { xs: "100%", lg: "66.666%" },
                maxWidth: "100%"
              }}
            >
              <Typography variant="body1">
                {searchResults.count} {searchResultFoundLabel}
              </Typography>
            </Box>
          )}

        {searchResults !== null &&
          searchResults !== undefined &&
          searchResults.rows.length > 0 &&
          searchResults.count > 0 && (
            <>
              <Box
                className="manageUsers_card_visible"
                sx={{ width: { xs: "100%", lg: "66.666%" }, maxWidth: "100%" }}
              >
                <CardList
                  data={{ ...searchResults }}
                  onAnyPaginationAction={initiateSearch}
                  pathName={pathName}
                  hideFooterPagination={hideFooterPagination}
                  componentAccess={componentAccess}
                  pageNumber={pageNumber}
                  rowPerPage={rowPerPage}
                  history={history}
                />
              </Box>
              <Box
                className="manageUsers_table_visible"
              >
                <ERPSGrid
                  data={{ ...searchResults }}
                  onAnyPaginationAction={initiateSearch}
                  history={history}
                  pathName={pathName}
                  dataGridWidth={sumOfColumnWidth ? "" : dataGridWidth || "dataGrid__box__container"}
                  sumOfColumnWidth={sumOfColumnWidth}
                  hideFooterPagination={hideFooterPagination}
                  componentAccess={componentAccess}
                  initialLoading={initialLoading}
                  initialStates={initialStates}
                  pageNumber={pageNumber}
                  rowPerPage={rowPerPage}
                  tableLabelText={pageTitle}
                />
              </Box>
            </>
          )}

        {(searchResults === null ||
          searchResults.count === null ||
          searchResults.count === -1) && (
          <Box
            mt={1}
            sx={{ width: { xs: "100%", lg: "66.666%" }, maxWidth: "100%" }}
          >
            <Typography variant="body1">{searchNotStarted}</Typography>
          </Box>
        )}
      </Box>
    </div>
  );
}
